import { getAssetURL } from "helpers/assets";

const TARALITE_ANIMATION_GCS_PATH = "taralite-com/assets/images/animations";

const loadingVar1 = getAssetURL(`${TARALITE_ANIMATION_GCS_PATH}/loading-variation-1.svg`);

export { loadingVar1 };
